import { render, staticRenderFns } from "./wrong_list.vue?vue&type=template&id=3e5ab4ef&"
import script from "./wrong_list.vue?vue&type=script&lang=js&"
export * from "./wrong_list.vue?vue&type=script&lang=js&"
import style0 from "./wrong_list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports